var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    class: ("promo-button promo-button__" + (_vm.color)),
    on: {
      "click": _vm.copyToClipboard
    }
  }, [_vm.copied ? _c('span', {
    staticClass: "promo-button__copied"
  }, [_vm._v(_vm._s(_vm.copiedText))]) : _c('span', {
    staticClass: "promo-button__text"
  }, [_vm._v(_vm._s(_vm.text))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }